import React from "react";
import { Link } from "react-router-dom";
import "./Error404.scss";

const Error404 = () => {
    return (
        <div className="error-container">
            <h1 className="error-title">404</h1>
            <p className="error-text">Oops! The page you are looking for doesn’t exist.</p>
            <Link to="/" className="error-btn">Go Home</Link>
        </div>
    );
};

export default Error404;
